import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { SHELL_PURGE_KEY, stripBootParams } from './app/core/error/shell-recovery';

bootstrapApplication(App, appConfig)
  .then(() => {
    try {
      sessionStorage.removeItem('boot-fail-count');
      sessionStorage.removeItem(SHELL_PURGE_KEY);
    } catch {
      // sessionStorage might be disabled.
    }
    const clean = stripBootParams(window.location.href);
    if (clean) history.replaceState(null, '', clean);
  })
  .catch((err) => {
    console.error(err);
    // Bundles loaded but bootstrap threw. The head script does the same
    // recovery a hard refresh would: drop the service worker once, then show
    // the static fallback only if that already failed.
    if (window.__jiopcRecoverShell) {
      window.__jiopcRecoverShell();
      return;
    }
    document.getElementById('boot-fallback')?.classList.add('boot-fallback--visible');
  });

